<div class="ticket">
    <div class="confirmation-swish">
        <div class="confirmation-swish-area">
            <div class="confirmation-swish-area__icon">
                <ridango-ui-icons name="swishConfirmation"></ridango-ui-icons>
            </div>

            <h1 class="confirmation-swish-area__title">{{ 'SWISH_CONFIRMATION_TITLE' | translate }}</h1>
            <p class="confirmation-swish-area__description">{{ 'SWISH_CONFIRMATION_DESCRIPTION' | translate }}</p>

            <div class="confirmation-swish-area__loader">
                <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
                </ridango-ui-basic-loading-spinner>
            </div>
        </div>
    </div>
</div>
